<template>
  <div class="page">
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <div class="header-title">
      <div class="header-info">
        <h5>超期总额</h5>
        <a
          ><span class="header-info-num">{{
            (overamount / 10000).toFixed(2)
          }}</span
          ><span class="header-info-unit">万元</span></a
        >
      </div>
      <div class="header-info">
        <h5>上月达成率</h5>
        <a
          ><span class="header-info-num">{{ activityrate }}</span
          ><span class="header-info-unit">%</span></a
        >
      </div>
      <div class="header-info">
        <h5>未超期总额</h5>
        <a
          ><span class="header-info-num">{{ sumamount }}</span>
          <span class="header-info-unit">元</span></a
        >
      </div>
    </div>

    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="table-info">
      <h5>未超期应收</h5>
      <div class="table-row table-header">
        <span class="table-row-left">月份</span
        ><span class="table-row-right">金额</span>
      </div>
      <div class="table-row" v-for="(item, index) in array" :key="index">
        <span class="table-row-left">{{ item.text }}</span
        ><span class="table-row-right">{{ item.aramount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import FilterBar from "@/components/FilterBar.vue";
import F2 from "@antv/f2/lib/index-all";

export default {
  components: {
    FilterBar,
  },
  data() {
    return {
      selected: "应收排程",
      filters: [
        {
          type: "currency",
          name: "cd_currency",
        },
      ],
      overamount: 0,
      activityrate: 0,
      sumamount: 0,
      array: [],
    };
  },
  mounted() {
    this.onSearch();
  },
  methods: {
    toggle(val) {
      this.selected = val;
    },
    onSearch() {
      let me = this,
        filterBar = me.$refs.filterBar,
        currency = filterBar.getCondition();

      let params = {
        currency: currency[0].value.substring(1,4),
      };

      me.$ajax({
        url: "/api/money/arschedule/arschedule",
        params,
      }).then(function (res) {
        if (res.success) {
          me.overamount = res.data.overamount;
          me.activityrate = res.data.activityrate.toFixed(2);
          me.sumamount = res.data.sumamount.toFixed(2);
          me.array = res.data.items;
          me.initChart();
        }
      });
    },
    initChart() {
      let me = this,
        el = this.$el.querySelector(".myChart");

      let arr = [];
      el.style.width = "100%";
      el.style.height = "320px";

      me.array.map((element) => {
        arr.push({
          ...element,
          const: "const",
        });
      });
      arr.push({
        aramount: me.overamount,
        const: "const",
        text: "超期总额",
      });

      const chart = new F2.Chart({
        id: "myChart",
        pixelRatio: window.devicePixelRatio,
      });
      chart.source(arr);
      chart.coord("polar", {
        transposed: true,
        radius: 0.75,
      });
      chart.legend(false);
      chart.axis(false);
      chart.tooltip(false);

      // 添加饼图文本
      chart.pieLabel({
        sidePadding: 40,
        label1: function label1(data, color) {
          return {
            text: data.text,
            fill: color,
          };
        },
        label2: function label2(data) {
          return {
            text: String(Math.floor(data.aramount * 100) / 100).replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
            ),
            fill: "#808080",
            fontWeight: "bold",
          };
        },
      });

      chart
        .interval()
        .position("const*aramount")
        .color("text", [
          "#1890FF",
          "#13C2C2",
          "#2FC25B",
          "#FACC14",
          "#F04864",
          "#1AA034",
          "#EF1463",
        ])
        .adjust("stack");
      chart.render();
    },
  },
};
</script>

<style scoped>
.page {
  background-color: #fff;
}
.header-title {
  width: 100%;
  display: flex;
  flex-direction: row;
}
.header-info {
  flex-grow: 1;
  flex-basis: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.header-info > h5 {
  display: block;
  text-align: center;
  height: 40px;
  line-height: 40px;
  width: 100%;
  background: #edfbff;
  color: #517ea9;
  font-size: 12px;
}
.header-info > a {
  /* display: block; */
  text-align: center;
  /* margin-top: 10px; */
  width: 100%;
  display: flex;
  justify-content: center;
}
.header-info .header-info-num {
  font-size: 22px;
  color: #35baf6;
  margin: 0px 5px;
}
.header-info:first-child .header-info-num {
  color: red;
}
.header-info-unit {
  font-size: 12px;
  padding-top: 10px;
}
.table-info {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.table-info h5 {
  text-align: center;
  font-size: 14px;
  color: #517ea9;
  margin: 10px 0px;
}
.table-header {
  display: flex;
  /* height: 36px; */
  text-align: center;
  border-top: 1px solid #35baf6;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #35baf6;
}
.table-row > span {
  padding: 5px 0px;
  text-align: center;
  font-size: 14px;
  color: #333;
  border-left: 1px solid #35baf6;
}
.table-row > span:first-child {
  border-left: 0px solid #35baf6;
}
.table-row-left {
  width: 100px;
  color: #3e80f6;
}
.table-row-right {
  flex: 1;
}
</style>